import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { Radium } from "higher-order-components"
import COLOR_PALETTE from "constants/color-palette"
import classnames from "classnames"
import typographyStyles from "AtomicComponents/Typography/Typography.less"

const Splitter = () => <span style={{ ...styles.text, color: "#6D6D6D", margin: "0 0.75em" }}>{">"}</span>

const RadiumLink = Radium(Link)

const Breadcumb = ({ items = [], hideOnMobile }) => (
  <div style={[styles.base, hideOnMobile ? styles.hideOnMobile : {}]}>
    <ul style={styles.list}>
      {items
        .map((crumb, index) => {
          let label = crumb || "[undefined]"
          let href = "/mymazda"
          if (typeof crumb !== "string") {
            label = crumb.label || "[undefined]"
            href = crumb.href /* eslint-disable-line */
          }
          return (
            <li key={index} style={styles.listItem}>
              {index === items.length - 1 ? (
                <span style={[styles.text, { color: "#6D6D6D" }]}>{label}</span>
              ) : (
                <RadiumLink
                  style={{
                    ...styles.text,
                    ...{ ":hover": { color: COLOR_PALETTE.WHITE } }
                  }}
                  className={classnames({
                    [typographyStyles.withoutStyle]: true
                  })}
                  to={href}>
                  {label}
                </RadiumLink>
              )}
            </li>
          )
        })
        .reduce(
          (all, item, index) =>
            all.concat(
              item,
              index < items.length - 1 ? <Splitter key={"splitter-" + index} /> : null
            ), // Add splitter after all except last items
          []
        )}
    </ul>
  </div>
)

const styles = {
  base: {
    marginLeft: "1.5em",
    height: "100%",
    alignItems: "center",
    display: "flex"
  },
  hideOnMobile: {
    display: "none",
    "@media (min-width: 800px)": {
      display: "flex"
    }
  },
  list: {
    listStyleType: "none",
    margin: "0",
    padding: "0"
  },
  listItem: {
    display: "inline-block"
  },
  text: {
    color: "#A3A3A3",
    fontWeight: 600,
    letterSpacing: "0.08em",
    textDecoration: "none",
    transition: "color 0.25s"
  }
}

Breadcumb.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        label: PropTypes.string,
        href: PropTypes.string
      })
    ])
  ),
  hideOnMobile: PropTypes.bool
}

export default Radium(Breadcumb)



// WEBPACK FOOTER //
// ./src/containers/mymazda/navigation/breadcrumb.jsx